// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1uoaE","right":"styles_right__yG5Ve"};